import { render } from "./documents.vue?vue&type=template&id=145ec832&scoped=true&ts=true&lang=pug"
import script from "./documents.vue?vue&type=script&lang=ts"
export * from "./documents.vue?vue&type=script&lang=ts"

import "./documents.vue?vue&type=style&index=0&id=145ec832&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145ec832"]])

export default __exports__